import { useMemo, useState } from "react";
import { useQuery } from "react-query";
import { getMetricsFacebookAds } from "../../../services/metricsFacebook";
import { CardDashboard } from "../CardDashboard";
import { CardGraph } from "../CardGraph";
import { Header } from "../Header";
import { Box, Grid, LinearProgress, Stack, Typography } from "@mui/material";
import { useStyles } from "../styles";

export function FacebookADS() {
  const styles = useStyles();
  const [adsReach, setAdsReach] = useState([{}]); 
  const [adsImpressions, setAdsImpressions] = useState([{}]);
  const [adsFrequecy, setAdsFrequecy] = useState([{}]); 
  const [adsClicks, setAdsClicks] = useState([{}]);
  const [adsAge, setAdsAge] = useState([{}]);
  const [adsGender, setAdsGender] = useState([{}]);
  const [adsDevices,setDevices] = useState([{}]);
  const [adsPlataforms, setAdsPlataform] = useState([{}]);
  

  const facebookAdsMetrics = useQuery(
    "facebookAdsMetrics",
    getMetricsFacebookAds,
    {
      onSuccess(data) {
          console.log(data)
      },
    }
  );

  const imrpessionsFacebookAds = useMemo(() => {
    return facebookAdsMetrics.data?.metrics.impressions;
  }, [facebookAdsMetrics.data]);
    
  const reachFacebookAds = useMemo(() => {
    return facebookAdsMetrics.data?.metrics.reach;
  }, [facebookAdsMetrics.data]);

  const frequencyFacebookAds = useMemo(() => {
    return facebookAdsMetrics.data?.metrics.frequency;
  }, [facebookAdsMetrics.data]);
  
  const clicksFacebookAds = useMemo(() => {
    return facebookAdsMetrics.data?.metrics.clicks;
  }, [facebookAdsMetrics.data]);

  // Data Graphs
  useMemo(() => {
    const dataReach = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.reach,
    }));
    const dataImpressions = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.impressions,
    }));
    const dataFrequecy = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.frequency,
    }));
    const dataClicks = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.clicks,
    }));
    setAdsReach([{ name: 'Alcance', data: dataReach }]);
    setAdsImpressions([{ name: 'Impressões', data: dataImpressions }]);
    setAdsFrequecy([{ name: 'Frequencia', data: dataFrequecy }]);
    setAdsClicks([{ name: 'Clicks', data: dataClicks }]);

    //IDADE------------------------------------------
    const age_18_24_reach = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.age_18_24_reach,
    }));
    const age_18_24_impressions = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.age_18_24_impressions,
    }));
    const age_25_34_reach = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.age_25_34_reach,
    }));
    const age_25_34_impressions = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.age_25_34_impressions,
    }));
    const age_35_44_reach = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.age_35_44_reach,
    }));
    const age_35_44_impressions = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.age_35_44_impressions,
    }));
    const age_45_54_reach = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.age_45_54_reach,
    }));
    const age_45_54_impressions = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.age_45_54_impressions,
    }));
    const age_55_64_reach = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.age_55_64_reach,
    }));
    const age_55_64_impressions = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.age_55_64_impressions,
    }));
    const age_65_plus_reach = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.age_65_plus_reach,
    }));
    const age_65_plus_impressions = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.age_65_plus_impressions,
    }));

    setAdsAge([
      {
        name: 'Alcance - 18-24',
        data: age_18_24_reach,
        color: '#F0BA7A'
      },
      {
        name: 'Impressões - 18-24',
        data: age_18_24_impressions,
        color: '#F0BA7A'
      },
      {
        name: 'Alcance - 25-34',
        data: age_25_34_reach,
        color: '#86F09C'
      },
      {
        name: 'Impressões - 25-34',
        data: age_25_34_impressions,
        color: '#86F09C'
      },
      {
        name: 'Alcance - 35-44',
        data: age_35_44_reach,
        color: '#F08F6E'
      },
      {
        name: 'Impressões - 35-44',
        data: age_35_44_impressions,
        color: '#F08F6E'
      },
      {
        name: 'Alcance - 45-54',
        data: age_45_54_reach,
        color: '#56C0F0'
      },
      {
        name: 'Impressões - 45-54',
        data: age_45_54_impressions,
        color: '#56C0F0'
      },
      {
        name: 'Alcance - 55-64',
        data: age_55_64_reach,
        color: '#F06276'
      },
      {
        name: 'Impressões - 55-64',
        data: age_55_64_impressions,
        color: '#F06276'
      },
      {
        name: 'Alcance - 65+',
        data: age_65_plus_reach,
        color: '#F0D989'
      },
      {
        name: 'Impressões - 65+',
        data: age_65_plus_impressions,
        color: '#F0D989'
      },
    ]);

    //GENERO------------------------------------------------
    const female_reach = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.female_reach,
    }));
    const female_impressions = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.female_impressions,
    }));
    const male_reach = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.male_reach,
    }));
    const male_impressions = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.male_impressions,
    }));
    const unknown_reach = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.unknown_reach,
    }));
    const unknown_impressions = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.unknown_impressions,
    }));

    setAdsGender([
      {
        name: 'Alcance Feminino',
        data: female_reach,
        color: '#FCA4F6'
      },
      {
        name: 'Impressões Feminino',
        data: female_impressions,
        color: '#FCA4F6'
      },
      {
        name: 'Alcance Masculino',
        data: male_reach,
        color: '#4996F5'
      },
      {
        name: 'Impressões Masculino',
        data: male_impressions,
        color: '#4996F5'
      },
      {
        name: 'Alcance Desconhecido',
        data: unknown_reach,
        color: '#21FCE5'
      },
      {
        name: 'Impressões Desconhecido',
        data: unknown_impressions,
        color: '#21FCE5'
      },
    ]);


    //DISPOSITIVOS------------------------------------------
    const desktopReach = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.desktop_reach,
    }));
    const desktopImpressions = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.desktop_impressions,
    }));
    const mobileReach = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.mobile_reach,
    }));
    const mobileImpressions = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.mobile_impressions,
    }));
    const mobileWebReach = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.mobile_web_reach,
    }));
    const mobileWebImpressions = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.mobile_web_impressions,
    }));

    setDevices([
      {
        name: 'Alcance em computadores',
        data: desktopReach,
        color: '#764924'
      },
      {
        name: 'Impressões em computadores',
        data: desktopImpressions,
        color: '#DB7F9A'
      },
      {
        name: 'Alcance pelo aplicativo',
        data: mobileReach,
        color: '#AF86F0'
      },
      {
        name: 'Impressões pelo aplicativo',
        data: mobileImpressions,
        color: '#88BADB'
      },
      {
        name: 'Alcance pelo navegador',
        data: mobileWebReach,
        color: '#66FFA2'
      },
      {
        name: 'Impressões pelo navegador',
        data: mobileWebImpressions,
        color: '#FEFFC3'
      },
    ]);
//PLATAFORMAS------------------------------------------
    const facebookReachMetrics = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.facebook_reach,
    }));
    const facebookImpressionsMetrics = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.facebook_impressions,
    }));
    const instagramReachMetrics = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.instagram_reach,
    }));
    const instagramImpressionMetrics = facebookAdsMetrics.data?.metrics.metricsInMonth.map((value: any) => ({
      x: value.date.toUpperCase(),
      y: value.instagram_impressions,
    }));  
    setAdsPlataform([
      {
        name: 'Facebook Alcance',
        data: facebookReachMetrics,
        color: '#5C3BBF'
      },
      {
        name: 'Facebook Impressões',
        data: facebookImpressionsMetrics,
        color: '#32CDCD'
      },
      {
        name: 'Instagram Alcance',
        data: instagramReachMetrics,
        color: '#FAB06B'
      },
      {
        name: 'Instagram Impressões',
        data: instagramImpressionMetrics,
        color: '#DB7F95'
      }
    ]);
  }, [facebookAdsMetrics.data?.metrics.metricsInMonth]);

  if (facebookAdsMetrics.isLoading) {
    return (
      <Stack
        spacing={2}
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="62vh"
      >
        <Typography variant="subtitle1">Buscando informações</Typography>
        <LinearProgress variant="indeterminate" sx={{ width: "50%" }} />
      </Stack>
    );
  }

  return (
    <Stack spacing={2} overflow="overlay" height="62vh">
      <Box className={styles.root}>
        <Header
          title="Impulsionamento"
          subTitle="Veja os resultados das publicações Impulsionadas."
          showButtonUpdate={false}
          isLoading={false}
          buttonClick={() => {}}
        />

        <Stack>
          <Grid
            container
            display="flex"
            p="24px 24px 0 0"
            spacing={2}
            flexWrap="wrap"
          >
            <Grid item md={5.5} lg={3} width="100%">
              <CardDashboard
                insights={reachFacebookAds}
                title={"Alcance"}
                text={
                  "Número de contas que viram o seu anúncio pelo menos umas vez."
                }
              />
            </Grid>
            <Grid item md={5.5} lg={3} width="100%">
              <CardDashboard
                insights={imrpessionsFacebookAds}
                title={"Impressões"}
                text={
                  "Número de visualizações que seus anúncios tiveram, uma conta pode ter visto mais de uma vez."
                }
              />
            </Grid>
            <Grid item md={5.5} lg={3} width="100%">
              <CardDashboard
                insights={frequencyFacebookAds}
                title={"Frequência"}
                text={
                  "Média de vezes que seu anúncio foi visualizado por uma mesma conta."
                }
              />
            </Grid>
            <Grid item md={5.5} lg={3} width="100%">
              <CardDashboard
                insights={clicksFacebookAds}
                title={"Clicks"}
                text={
                  "Número de clicks dos seus anúncios."
                }
              />
            </Grid>
          </Grid>
          <Stack flexDirection="column" p="24px 0" gap={3}>
            <Header />
            <Grid
              container
              display="flex"
              p="0 24px 0 0"
              spacing={4}
              flexWrap="wrap"
            >
              <Grid item md={12} lg={6} width="100%">
                <CardGraph 
                  title="Alcance" 
                  text={'Alcance por mês'}
                  data_type={'REACH'}
                  data={adsReach} 
                />
              </Grid>
              <Grid item md={12} lg={6} width="100%">
                <CardGraph 
                  title="Impressões" 
                  text={'Impressões por mês'}
                  data_type={'IMPRESSIONS'}
                  data={adsImpressions} 
                />
              </Grid>
              <Grid item md={12} lg={6} width="100%">
                <CardGraph 
                  title="Frequência" 
                  text={'Frequência de visualizações por mês'} 
                  data_type={'ADS_FREQUENCY'}
                  data={adsFrequecy} 
                />
              </Grid>
              <Grid item md={12} lg={6} width="100%">
                <CardGraph 
                  title="Clicks" 
                  text={'Clicks por mês'}
                  data_type={'ADS_CLICKS'}
                  data={adsClicks} 
                />
              </Grid>
              <Grid item md={12} lg={12} width="100%">
                <CardGraph 
                  title="Idade" 
                  text={'Métricas dos anúncios por faixa de idade'}
                  data_type={'ADS_AGE'}
                  data={adsAge} 
                />
              </Grid>
              <Grid item md={12} lg={12} width="100%">
                <CardGraph 
                  title="Genero" 
                  text={'Métricas dos anúncios por Genero'}
                  data_type={'ADS_GENDER'}
                  data={adsGender} 
                />
              </Grid> 
              <Grid item md={12} lg={12} width="100%">
                <CardGraph 
                  title="Dispositivos" 
                  text={'Métricas dos anúncios por dispositivo'}
                  data_type={'ADS_DEVICE'}
                  data={adsDevices} 
                />
              </Grid>             
              <Grid item md={12} lg={12} width="100%">
                <CardGraph 
                  title="Plataformas" 
                  text={'Metricas dos anúncios no Facebook e Instagram'}
                  data_type={'ADS_PLATFORM'}
                  data={adsPlataforms} 
                />
              </Grid>

            </Grid>
          </Stack>
        </Stack>
      </Box>
    </Stack>
  );
}
